var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDiscover = function SvgDiscover(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "discover_svg__ic_discover",
    viewBox: "0 0 33 22"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".discover_svg__cls-2{fill:#ff6f00}.discover_svg__cls-4{fill:#303030}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "discover_svg__Group_59",
    "data-name": "Group 59"
  }, /*#__PURE__*/React.createElement("path", {
    id: "discover_svg__Path_52",
    d: "M29.92 0H3.08A3.025 3.025 0 0 0 0 3.017v15.966A3.06 3.06 0 0 0 3.08 22h26.84A3.025 3.025 0 0 0 33 18.983V3.017A3.025 3.025 0 0 0 29.92 0z",
    "data-name": "Path 52",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "discover_svg__Path_53",
    d: "M40 23a59.6 59.6 0 0 1-22 8.25v.55h20.9l1.65-1.65V23z",
    className: "discover_svg__cls-2",
    "data-name": "Path 53",
    transform: "translate(-8.1 -10.405)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "discover_svg__Path_54",
    d: "M29.92 1.1a1.924 1.924 0 0 1 1.98 1.92v15.963a1.958 1.958 0 0 1-1.98 1.92H3.08a1.924 1.924 0 0 1-1.98-1.92V3.017A1.924 1.924 0 0 1 3.08 1.1h26.84m0-1.1H3.08A3.025 3.025 0 0 0 0 3.017v15.966A3.06 3.06 0 0 0 3.08 22h26.84A3.025 3.025 0 0 0 33 18.983V3.017A3.025 3.025 0 0 0 29.92 0z",
    "data-name": "Path 54",
    fill: "#d8d8d8"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "discover_svg__Group_61",
    "data-name": "Group 61",
    transform: "translate(3.63 8.718)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "discover_svg__Path_55",
    d: "M31.59 18.245a2.364 2.364 0 0 0-.6-1.54 2.112 2.112 0 0 0-1.54-.605 2.113 2.113 0 0 0-2.15 2.145 2.145 2.145 0 1 0 4.29 0z",
    className: "discover_svg__cls-2",
    "data-name": "Path 55",
    transform: "translate(-15.915 -15.99)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "discover_svg__Group_60",
    "data-name": "Group 60"
  }, /*#__PURE__*/React.createElement("path", {
    id: "discover_svg__Path_56",
    d: "M24.19 19.09a1.237 1.237 0 0 1-.935.44 1.375 1.375 0 0 1-1.375-1.43 1.614 1.614 0 0 1 .385-1.045 1.3 1.3 0 0 1 .88-.385 1.265 1.265 0 0 1 .99.44v-.935a2.058 2.058 0 0 0-.99-.275 2.589 2.589 0 0 0-1.43.6l-.33.33A2.648 2.648 0 0 0 21 18.155a2.068 2.068 0 0 0 2.145 2.09 2.454 2.454 0 0 0 .99-.275l.055-.88z",
    className: "discover_svg__cls-4",
    "data-name": "Path 56",
    transform: "translate(-13.08 -15.9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "discover_svg__Path_57",
    d: "m37.96 16.74-.935 2.31-1.1-2.75H35.1l1.705 4.18h.44l1.76-4.18h-.88z",
    className: "discover_svg__cls-4",
    "data-name": "Path 57",
    transform: "translate(-19.425 -16.08)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "discover_svg__Path_58",
    d: "M42.8 18.115v2.255h2.31v-.66h-1.485v-1.1h1.43v-.71h-1.43v-.88h1.485v-.72H42.8z",
    className: "discover_svg__cls-4",
    "data-name": "Path 58",
    transform: "translate(-22.89 -16.08)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "discover_svg__Path_59",
    d: "M7.755 16.3H6.6v4.07h1.155a2.218 2.218 0 0 0 1.43-.44 2.123 2.123 0 0 0 .77-1.6 2.011 2.011 0 0 0-2.2-2.03zm.99 3.08a1.642 1.642 0 0 1-1.1.33H7.37v-2.695h.22a1.642 1.642 0 0 1 1.1.33 1.377 1.377 0 0 1 .44.99 1.254 1.254 0 0 1-.385 1.045z",
    className: "discover_svg__cls-4",
    "data-name": "Path 59",
    transform: "translate(-6.6 -16.08)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "discover_svg__Rectangle_253",
    d: "M0 0h.77v4.07H0z",
    className: "discover_svg__cls-4",
    "data-name": "Rectangle 253",
    transform: "translate(3.74 .22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "discover_svg__Path_60",
    d: "M17.24 17.9c-.5-.165-.605-.275-.605-.5 0-.275.275-.44.605-.44a.86.86 0 0 1 .66.33l.44-.55a1.922 1.922 0 0 0-1.21-.44 1.19 1.19 0 0 0-1.265 1.155c0 .6.275.825.99 1.1a1.228 1.228 0 0 1 .55.275.561.561 0 0 1 .275.44.61.61 0 0 1-.605.605.98.98 0 0 1-.88-.55l-.5.5a1.6 1.6 0 0 0 1.43.77 1.332 1.332 0 0 0 1.43-1.32c-.155-.775-.435-1.05-1.315-1.375z",
    className: "discover_svg__cls-4",
    "data-name": "Path 60",
    transform: "translate(-10.695 -16.08)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "discover_svg__Path_61",
    d: "M49.705 18.665a1.088 1.088 0 0 0 .935-1.155c0-.77-.55-1.21-1.43-1.21H48v4.07h.77v-1.595h.11l1.1 1.595h.935zm-.715-.5h-.275v-1.26h.275c.5 0 .77.22.77.6.055.445-.22.665-.77.665z",
    className: "discover_svg__cls-4",
    "data-name": "Path 61",
    transform: "translate(-25.23 -16.08)"
  })))));
};
export default SvgDiscover;